import Link from "next/link";
import Image from "next/image";

export default function PremiumNavbar({
  onSubscribe,
}: {
  onSubscribe?: () => void;
}) {
  return (
    <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-gray-100 pt-4">
      <div className="max-w-screen-xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex h-16 justify-between items-center">
          <div className="flex-shrink-0">
            <Link href="/">
              <Image
                src="/bannerLogo.png"
                alt="WebFindsFriday Logo"
                width={250}
                height={70}
                className="h-14 w-auto"
                priority
              />
            </Link>
          </div>
          <div className="flex items-center space-x-3">
            <Link
              href="/previous-issues"
              className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 hover:text-black transition-colors"
            >
              Archive
            </Link>
            <button
              onClick={onSubscribe}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-black shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black transition-colors"
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
